import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '~/lib/bn-material-ui';

export default function ContactMill() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return <>
    <Button
      onClick={handleOpen}
      variant='text'
    >
      Contact Mill
    </Button>
    <Dialog open={open} onClose={handleClose} aria-labelledby='responsive-dialog-title'>
      <DialogTitle id='responsive-dialog-title'>
        Contact Mill
      </DialogTitle>
      <DialogContent>
        If there is an issue with this order, please contact your mill representative
        as soon as possible to ensure you receive the appropriate deliveries.
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  </>;
}
